import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import BottomNav from '../components/BottomNav';
import Topbar from '../components/Topbar';
import { useAppStore, useCheckoutStore } from '../store/Store';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { Typography } from 'antd';


// Import drawer components
import FilterDrawer from '../components/drawers/ProductFiltersDrawer';
import CartDrawer from '../components/drawers/CartDrawer';
import AccountDrawer from '../components/drawers/AccountDrawer';
import WishlistDrawer from '../components/drawers/WishlistDrawer';
import ProductDrawer from '../components/drawers/ProductDrawer';

import AddToCartModal from "../components/AddToCartModal"
import PremiumChatModal from '../components/ChatModal';
import { CloseOutlined } from '@ant-design/icons';

const AppLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { Title } = Typography;

  const { currentPage, setCurrentPage, openDrawer, activeDrawer, closeDrawer, cartCount, isAnyDrawerOpen } = useAppStore();
  const { setLastCheckoutVisit, clearCheckout } = useCheckoutStore();
  const isProductPage = location.pathname.startsWith("/shop/") && location.pathname.split("/").length === 4;
  const isShopPage = location.pathname === "/shop" || location.pathname === "/"
  const isLoginPage = location.pathname === "/login";
  const isWishlistPage = location.pathname === "/wishlist"

  const handleNavigate = (page) => {
    setCurrentPage(page);
    navigate(`/${page}`);
  };

  useEffect(() => {
    if (location.pathname === '/checkout') {
      setLastCheckoutVisit();
    } else {
      sessionStorage.removeItem('iniChk_flg');
    }
  }, [location.pathname]);


  const handleIconClick = (iconName) => {
    console.log(`${iconName} button is clicked`);
    if (iconName === 'user') {
      openDrawer('account');
    } else {
      openDrawer(iconName);
    }
  };


  useEffect(() => {
    const checkoutPaths = ['/checkout', '/confirmed-order'];
    if (!checkoutPaths.includes(location.pathname)) {
      clearCheckout();
    }
  }, [location.pathname, clearCheckout]);

  const showChatButton = ((isShopPage || isProductPage || isWishlistPage) && !isAnyDrawerOpen())
  const [isChatOpen, setIsChatOpen] = useState(false);


  return (
    <Box sx={{ height: '100dvh', width: '100%', display: 'flex', flexDirection: 'column', bgcolor: '#f9fafb', position: 'relative' }}>
      {/* Topbar */}
      {!isLoginPage &&
        <Box sx={{ height: { xs: '48px', sm: '72px' }, width: '100%', position: 'fixed', top: 0, left: 0, zIndex: 1000, display: 'flex', alignItems: 'center', bgcolor: '#fff', boxShadow: '0 1px 5px rgba(0,0,0,0.05)', justifyContent: 'center' }}>
          <Topbar currentPage={currentPage} onNavigate={handleNavigate} onIconClick={handleIconClick} />
        </Box>}

      {/* Main Content */}
      <Box sx={{ flex: 1, width: '100%', overflowY: 'auto', bgcolor: '#f9fafb', mt: { xs: '48px', sm: '72px' }, mb: { xs: '60px', sm: 0 } }}>
        <Box sx={{ maxWidth: '1280px', margin: '0 auto', width: '100%', px: { xs: 1, sm: 2, md: 2 } }}>
          <Outlet />
        </Box>

        {/* <Box sx={{height:'150px', width:'100%', bgcolor:'red'}}>
          THis might be footer
        </Box> */}
      </Box>



      {showChatButton &&

        <Box sx={{
          position: 'fixed', bottom: { xs: '80px', sm: '65px' },
          right: { xs: '20px', sm: '65px' },
          zIndex: '100000',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>

          <Box
            sx={{

              height: { xs: '56px', sm: '65px' },
              width: { xs: '56px', sm: '65px' },
              borderRadius: '50%',
              cursor: 'pointer',
              bgcolor: '#ffffff',
              boxShadow: 4,

            }}

            onClick={() => setIsChatOpen(true)}
          >

            <DotLottieReact
              src="https://lottie.host/249a6927-807a-4b13-ab34-850d73d73312/9b8Vo7DT3R.lottie"
              loop
              autoplay
            />

            <Box
              sx={{
                position: 'absolute',
                bottom: 5,
                right: 4,
                width: 10,
                height: 10,
                bgcolor: '#22c55e',
                borderRadius: '50%',
                border: '2px solid #fff',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  borderRadius: '50%',
                  animation: 'ripple 1.5s infinite ease-in-out',
                  border: '1px solid #22c55e',
                },
                '@keyframes ripple': {
                  '0%': { transform: 'scale(.8)', opacity: 1 },
                  '100%': { transform: 'scale(2.4)', opacity: 0 },
                },
              }}
            />
          </Box>
        </Box>
      }







      {/* Bottom Navigation */}
      {(
        ((!isProductPage && location.pathname !== '/cart') || (location.pathname === '/cart' && cartCount === 0))
        && location.pathname !== '/checkout'
        && location.pathname !== '/confirmed-order' && !isLoginPage
      ) ? (
        <Box
          sx={{
            height: '60px',
            width: '100%',
            display: { xs: 'flex', sm: 'none' },
            bgcolor: '#fff',
            justifyContent: 'space-around',
            alignItems: 'center',
            zIndex: 1000,
            position: 'fixed',
            bottom: 0,
            left: 0,
            paddingBottom: 'env(safe-area-inset-bottom)',
            boxSizing: 'border-box',
            boxShadow: '0 1px 5px rgba(0,0,0,0.05)'
          }}
        >
          <BottomNav currentPage={currentPage} onNavigate={handleNavigate} onIconClick={handleIconClick} />
        </Box>
      ) : null}


      {/* Drawers - Each handles its own state */}
      <FilterDrawer open={activeDrawer === 'filter'} onClose={closeDrawer} />
      <CartDrawer open={activeDrawer === 'cart'} onClose={closeDrawer} />
      <WishlistDrawer open={activeDrawer === 'wishlist'} onClose={closeDrawer} />
      <AccountDrawer open={activeDrawer === 'account'} onClose={closeDrawer} />
      <ProductDrawer />
      <AddToCartModal />
      <PremiumChatModal isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
    </Box>
  );
};

export default AppLayout;